import ConfigService from '../index'
class EspacoService extends ConfigService {
    constructor(){
        super('agendalabs/api/v1/espacos/')
    }
}
export default EspacoService
